import { IRGBA } from "../interfaces/IColor";
import { UtilityMethods } from "./UtilityMethods";

export const nameof = <T>(name: keyof T) => name;

export const ascendingOrderValidation = (
  arr: number[],
  tierValidation = false
): number[] => {
  const errorIndexes: number[] = [];
  if (arr[0] < 1) {
    errorIndexes.push(0);
  }

  arr.forEach(function (x, i) {
    if (i > 0) {
      if (tierValidation) {
        if (x <= arr[i - 1] && i + 1 !== arr.length) {
          errorIndexes.push(i);
        }
      } else {
        if (x <= arr[i - 1]) {
          errorIndexes.push(i);
        }
      }
    }
  });
  return errorIndexes;
};

export const getNewErrors = (newErrors: any[], currentErrors: any[]) => {
  if (newErrors && newErrors.length === 0) return [];
  else if (currentErrors && currentErrors?.length === 0) return [];
  else {
    return newErrors.filter((item) => {
      return (
        currentErrors.findIndex(
          (c) => c.index === item.index && c.field === item.field
        ) > -1
      );
    });
  }
};

export function buildParamString(params: { [key: string]: any }): string {
  const paramsArray: string[] = [];

  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const value =
        typeof params[key] === "number" && isFinite(params[key])
          ? params[key]
          : params[key] || "";
      paramsArray.push(`${key}=${encodeURIComponent(value)}`);
    }
  }

  return paramsArray.join("&");
}

export function parseRGBA(rgbaString: string): IRGBA | null {
  const rgbaRegex =
    /^rgba?\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})(?:,\s*([01]?(?:\.\d+)?))?\)$/;
  const matches = rgbaString.match(rgbaRegex);

  if (!matches) {
    return null;
  }
  const color = {
    r: matches[1],
    g: matches[2],
    b: matches[3],
    a: matches[4] !== undefined ? matches[4] : "1", // Default alpha to 1 if not specified
  } as IRGBA;

  return color;
}

export function parseRGBAToString(rgbValue: IRGBA): string {
  return `rgba(${rgbValue?.r},${rgbValue?.g},${rgbValue?.b},${rgbValue?.a})`;
}

export function removeComma(value: string): string {
  if (!value) {
    return "";
  }
  return value.replace(/[,]/g, "");
}

export function removeSlashFromEnd(value: string): string {
  if (!value) {
    return "";
  }
  return value.replace(/[/]$/, "");
}

export function validateDecimalValue(value: string): boolean {
  return UtilityMethods.validateDecimalValue(value);
}
